<template>
  <i-ic-baseline-cleaning-services />
</template>
